import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import BackButton from '../../../../../components/UI/BackButton';
import { translate } from '../../../../../utils/util';

const OrderDetail = (props) => {
    const item = props.order?.items ? props.order?.items[0] : {}

    return (
        <div>
            <BackButton {...props} />
            <div className="container">
                <div className="card">
                    <div className="card-content" style={{ padding: '10px' }}>
                        <form>
                            <div className="row" style={{ marginBottom: '0' }}>
                                <div className="subtitle col s12" style={{ padding: '0px' }}>
                                    <span className="field f-1r truncate">{translate("line-picking:linepicking.order-details")}</span>
                                </div>
                                <div className="row">
                                    <div className="input-field no-padding col s6">
                                        <span className="field f-1r truncate">{item?.orderItemCode}</span>
                                        <label className="active" htmlFor="entryCode">{translate('line-picking:linepicking.material-code')}</label>
                                    </div>
                                    <div className="input-field no-padding col s4">
                                        <span className="field f-1r truncate">{item?.quantity}</span>
                                        <label className="active">{translate('line-picking:linepicking.amount')}</label>
                                    </div>
                                    <div className="input-field no-padding col s6">
                                        <span className="field f-1r">{item?.partnumber}</span>
                                        <label className="active">{translate('line-picking:linepicking.drawing')}</label>
                                    </div>
                                    <div className="input-field no-padding col s4">
                                        <span className="field f-1r truncate">{item?.location}</span>
                                        <label className="active">{translate('line-picking:linepicking.location')}</label>
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <span className="field f-1r truncate">{item?.auxcode}</span>
                                        <label className="active">{translate('line-picking:linepicking.requisition-number')}</label>
                                    </div>
                                </div>
                                <div className="input-field no-padding col s12">
                                    <span className="field f-1r truncate">{item?.observation}</span>
                                    <label className="active" htmlFor="nivel">{translate('line-picking:linepicking.justification')} </label>
                                </div>
                                <div className="input-field no-padding col s12">
                                    <span className="field f-1r truncate">{props.order?.createBy}</span>
                                    <label className="active" htmlFor="nivel">{translate('line-picking:linepicking.createBy')} </label>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        order: state.linePickingReducer.order
    };
};

const mapDispatchToProps = () => {
    return {
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(OrderDetail)));
